import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function connectSocket(token: string): Socket {
  socket = io(import.meta.env.VITE_APP_API_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnectionAttempts: 10,
    reconnectionDelay: 2000
  });

  // Pending audit 2026-10-30 (WEB-14): no `connect` log — it was noise in production (and a
  // backend-dependent line for the e2e coverage, see scripts/e2e/repo.cjs); the error stays,
  // dev-only, as analytics.ts/attribution.ts do.
  socket.on('connect_error', (err) => {
    if (process.env.NODE_ENV !== 'production') console.warn('[ws] connection error:', err.message);
  });

  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
